import React from "react";
// Legacy flat-sheet renderer for slot kinds that don't go through the
// shared DrawTemplate pipeline (currently `flat-legacy`: magnets, etc.).
// Renders the sheet as a positioned div with a white background and each
// cell as a positioned <img>. The parent <Slot> wrapper handles slot-level
// rotation + perspective via CSS transforms; we just lay out cells inside
// it in design-unit pixels.
export function FlatSlot({ slot, urls, cells }) {
    const w = slot.width;
    const h = slot.height;
    const slotIsPortrait = h >= w;
    return (React.createElement("div", { style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: `${w}px`,
            height: `${h}px`,
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.12)",
            boxSizing: "border-box",
        } }, cells.map((cell, i) => {
        var _a;
        const [fx, fy, fw, fh] = cell;
        const cellW = fw * w;
        const cellH = fh * h;
        const cellX = fx * w;
        const cellY = fy * h;
        const url = urls.length ? ((_a = urls[i % urls.length]) !== null && _a !== void 0 ? _a : null) : null;
        const rotatePhoto = photoRotationFor(cellW, cellH, slotIsPortrait, 0);
        return (React.createElement(Cell, { key: i, x: cellX, y: cellY, w: cellW, h: cellH, url: url, rotatePhoto: rotatePhoto }));
    })));
}
// Single cell: a positioned div containing an <img>. overflow:hidden clips
// any image that overflows the cell when its aspect ratio doesn't match
// (object-fit: cover handles the "fill-in" semantics the legacy SVG path
// did via preserveAspectRatio="xMidYMin slice"). Photo rotation kicks in
// for landscape cells inside portrait slots (matches SheetCells.photoRotationFor).
function Cell({ x, y, w, h, url, rotatePhoto, }) {
    if (!url) {
        return (React.createElement("div", { style: {
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                width: `${w}px`,
                height: `${h}px`,
                background: "#ccc",
            } }));
    }
    if (rotatePhoto === 0) {
        return (React.createElement("img", { src: url, alt: "", style: {
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                width: `${w}px`,
                height: `${h}px`,
                objectFit: "cover",
                objectPosition: "center top",
            } }));
    }
    // Rotated: render the photo at swapped dimensions, centred on the cell,
    // then rotate around the cell centre. Outer wrapper has overflow:hidden
    // so the rotated img can't extend past the cell.
    return (React.createElement("div", { style: {
            position: "absolute",
            left: `${x}px`,
            top: `${y}px`,
            width: `${w}px`,
            height: `${h}px`,
            overflow: "hidden",
        } },
        React.createElement("img", { src: url, alt: "", style: {
                position: "absolute",
                left: `${w / 2 - h / 2}px`,
                top: `${h / 2 - w / 2}px`,
                width: `${h}px`,
                height: `${w}px`,
                objectFit: "cover",
                objectPosition: "center top",
                transform: `rotate(${rotatePhoto}deg)`,
                transformOrigin: "center center",
            } })));
}
export function photoRotationFor(cellW, cellH, slotIsPortrait, slotRotatePhoto) {
    if (slotRotatePhoto !== 0)
        return slotRotatePhoto;
    const cellIsLandscape = cellW / Math.max(cellH, 1) > 1.2;
    return slotIsPortrait && cellIsLandscape ? 90 : 0;
}
